import { render, staticRenderFns } from "./LoginScreenCapacitacionesProlipa.vue?vue&type=template&id=0864545a&scoped=true"
import script from "./LoginScreenCapacitacionesProlipa.vue?vue&type=script&lang=js"
export * from "./LoginScreenCapacitacionesProlipa.vue?vue&type=script&lang=js"
import style0 from "./LoginScreenCapacitacionesProlipa.vue?vue&type=style&index=0&id=0864545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864545a",
  null
  
)

export default component.exports